import React from 'react';
import clsx from 'clsx';
import Img from '@/components/Img';
import { ButtonType } from '@/components/Button/Button';
import Icon from '@/components/Icon';
import styles from './Contact.module.scss';

interface IButton {
  id: number,
  title: string,
  type: ButtonType,
  link: string
}

type Image = {
  id: number;
  alternativeText: string | null;
  width: number;
  height: number;
  url: string;
};

interface IContactUsDetails {
  title: string;
  subtitle: string;
  contacts: {
    id: number;
    title: string;
    subtitle: string;
    data: string;
    icon?: Image,
    button?: IButton
  }[]
}

const getLink = (title: string, data: string) => {
  if (title?.toLowerCase()?.includes('mail')) {
    return `mailto:${data}`;
  }
  return data;
};

const ContactUsDetails = ({ data }: { data: IContactUsDetails }) => (
  <section className={clsx(styles.contactWrapper, 'custom')}>
    <div className={clsx(styles.contact, 'global-section')}>
      <div className={styles.textContent}>
        <h2>{data.title}</h2>
        <p className={styles.subtitle}>{data.subtitle}</p>
      </div>
      <div className={styles.contactContent}>
        {data.contacts.map((card) => (
          <div
            key={card.id}
            className={styles.contactCard}
          >
            {card.icon?.url ? (
              <Img
                src={card.icon?.url}
                height={32}
                width={32}
              />
            ) : (
              <Icon
                name='mail'
                size={32}
                color='white'
              />
            )}
            <div className={styles.contactCardDetails}>
              <h5>{card.title}</h5>
              <p className={styles.subTitle}>{card.subtitle}</p>
              <a
                href={getLink(card.title, card.data)}
                target={card.title?.toLowerCase()?.includes('mail') ? undefined : '_blank'}
                className={styles.link}
                rel='noreferrer'
              >
                {card.data}
              </a>
            </div>
            {card.button && (
            <a
              href={card.button.link}
              target='_blank'
              className={styles.addressLink}
              rel='noreferrer'
            >
              <span>{card.button.title}</span>
              <Icon
                name='chevron_right'
                size={24}
              />
            </a>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ContactUsDetails;
